<template>
  <li class="flex w-full items-center">
    <span
      v-if="showIcon"
      class="inline-flex mr-2 flex-shrink-0 icon-file w-8 h-8 bg-contain"
    ></span>
    <span class="truncate" :title="document.filename">{{
      document.filename
    }}</span>

    <div class="pl-4 ml-auto inline-flex items-center">
      <el-checkbox
        v-if="!hideAllowDownload"
        v-loading="isUploading"
        :disabled="isUploading"
        :value="document.allow_download"
        @change="(value) => onAllowDownloadChanged(document, value)"
        label="Allow download"
        class="mb-0 font-bold"
      />

      <a href @click.prevent="openRemoveModal(document)" class="font-bold ml-4">
        Remove
      </a>
      <TextButton
        v-if="startupId"
        @click="openDocument(document)"
        type="primary"
        size="lg"
        class="font-bold ml-4"
      >
        Open
      </TextButton>
      <a href class="handle ml-4">
        <i class="ion ion-drag text-muted"></i>
      </a>
    </div>
  </li>
</template>

<script>
import TextButton from 'components/common/TextButton.vue'

export default {
  props: {
    document: {
      type: Object,
      default: () => ({}),
    },
    startupId: String,
    showIcon: {
      type: Boolean,
      default: true,
    },
    hideAllowDownload: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TextButton,
  },
  data() {
    return {
      isRemoveInProgress: false,
      isUploading: false,
    }
  },
  methods: {
    async openRemoveModal(document) {
      try {
        await this.$confirm(
          `Are you sure you want to delete document ${document.filename}?`,
          'Confirm deletion',
        )
      } catch (err) {
        // removal canceled
        return
      }
      return await this.remove({ document })
    },
    async remove({ document }) {
      this.isRemoveInProgress = true
      await this.$store.dispatch('startupProfile/removeDocument', { document })
      this.isRemoveInProgress = false
      this.$message({ type: 'success', message: 'Document removed' })
    },
    async openDocument(document) {
      // This is here to fix expiring S3 links for Pitch Deck files. They expire by default in 1 hour
      // (this only makes sense when not editigin - at editor it might happen in the middle of adding a team member)
      await this.$store.dispatch('startupProfile/fetch', {
        id: this.startupId,
        delay: 750,
      })

      // XXX: this code assumes that clicked document is not removed at the backend
      const newDocument = this.$store.state.startupProfile.startup.documents.filter(
        (d) => {
          return d.id === document.id
        },
      )[0]
      let documentUrl = newDocument ? newDocument.url : null

      if (this.$store.state.startupProfile.startup.video_url) {
        documentUrl = this.$store.state.startupProfile.startup.video_url
      }
      if (!documentUrl) return
      window.open(documentUrl, '_blank').focus()
    },
    async onAllowDownloadChanged(document, value) {
      this.isUploading = true

      await this.$store.dispatch('startupProfile/updateDocument', {
        ...document,
        allow_download: value,
      })

      this.isUploading = false
    },
  },
}
</script>
